import React from 'react';
import { BACK_BTN_LABEL, FormBuilder, SUBMIT_BTN_LABEL } from 'commons-ui';

import { EDIT_FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG } from '../../formConfig';

import useEdit from './useEdit';

const EditFeatureSegment: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useEdit();
	return (
		<FormBuilder
			data={data}
			mode='edit'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			setShowLoader={setShowLoader}
			fieldConfig={EDIT_FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
			buttonLabels={{ discardLabel: BACK_BTN_LABEL, submitLabel: SUBMIT_BTN_LABEL }}
		/>
	);
};

export default EditFeatureSegment;
